import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';

//reemplazando valores de iniciales en estado

export default function ModalCostCenter(props) {
  const costCenter = props.model;

  return (
    <Modal
      title="Centro de costo"
      model={costCenter}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="pymt/expense-center"
    >
      <TextField
        label="Código"
        type="text"
        name="code"
        margin="normal"
        fullWidth
        defaultValue={!!costCenter ? costCenter.code : ''}
        required
        disabled={!!costCenter?.id}
      />
      <TextField
        label="Descripción"
        type="text"
        name="description"
        margin="normal"
        fullWidth
        defaultValue={!!costCenter ? costCenter.description : ''}
      />
    </Modal>
  );
}
